import React from "react";
import EntityList from "../EntityList/EntityList";
import swal from "sweetalert";
import SwalTestEmailForm from "./SwalTestEmailForm";
import { createRoot } from "react-dom/client";
import { defineMessages, FormattedMessage, injectIntl } from "react-intl";

import globalMessages from "../../intl/globalMessages";
import { withConfig } from "../../../../lib/config";
import EmailConfiguration from "./EmailConfiguration";
import { withPropertyConfiguration } from "../../../../components/property-configuration-provider";

const messages = defineMessages({
  ...globalMessages,
  sendTestEmail: {
    id: "app.emailTemplateList.sendTestEmail",
    description: "Send Test Email Prompt Title",
    defaultMessage: "Send test email",
  },
  sendTestEmailInstructions: {
    id: "app.emailTemplateList.sendTestEmailInstructions",
    description: "Send Test Email Prompt Instructions",
    defaultMessage: "Please provide an existing reservation id (PXXXXXXX) to populate email data.",
  },
  emailSentSuccess: {
    id: "app.emailTemplateList.emailSentSuccess",
    description: "Email sent message",
    defaultMessage: "Email successfully sent!",
  },
  emailSentFailed: {
    id: "app.emailTemplateList.emailSentFailed",
    description: "Email sent failed",
    defaultMessage: "Email could not be sent",
  },
  send: {
    id: "app.emailTemplateList.send",
    description: "Send action",
    defaultMessage: "Send",
  },
  ALL: {
    id: "app.emailTemplateList.destinationType.all",
    description: "Destination type",
    defaultMessage: "Todos",
  },
  GUEST: {
    id: "app.emailTemplateList.destinationType.guest",
    description: "Destination type",
    defaultMessage: "Huéspedes",
  },
  PROPERTY: {
    id: "app.emailTemplateList.destinationType.property",
    description: "Destination type",
    defaultMessage: "Establecimiento",
  },
});

function isTestEmailAvailable({ entity }) {
  return (
    entity.type === "RESERVATION_CONFIRMATION" ||
    entity.type === "POST_STAY" ||
    entity.type === "PRE_STAY"
  );
}

class EmailTemplateList extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.getCustomActions = this.getCustomActions.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handlePromptSendTestEmail = this.handlePromptSendTestEmail.bind(this);
    this.handleSendTestEmail = this.handleSendTestEmail.bind(this);
    this.handleOnChangeTestEmailData = this.handleOnChangeTestEmailData.bind(this);
    this.displaySuccessAlert = this.displaySuccessAlert.bind(this);
    this.displayErrorAlert = this.displayErrorAlert.bind(this);
    //Entities are copied to the state because they can change?
    // but if entities come from the parent shouldn't I change it there?
    // what will I do after an update in the list?
    // the easiest would be to just request the list once again
    // and fetch the updates
    this.state = {
      entities: [],
      destinationEmail: "",
      reservationId: "",
    };
  }

  componentDidMount() {}

  componentWillUnmount() {}

  displaySuccessAlert() {
    swal(
      this.props.intl.formatMessage(messages.success),
      this.props.intl.formatMessage(messages.emailSentSuccess),
      "success"
    );
  }

  displayErrorAlert() {
    swal(
      this.props.intl.formatMessage(messages.failed),
      this.props.intl.formatMessage(messages.emailSentFailed),
      "error"
    );
  }

  getCustomActions() {
    return [
      {
        icon: "fa fa-envelope",
        tooltipId: "send-custom",
        tooltipText: this.props.intl.formatMessage(messages.sendTestEmail),
        onExecute: this.handlePromptSendTestEmail,
        isAvailable: isTestEmailAvailable,
      },
    ];
  }

  handleToggle({ event, field, entity }) {
    //If successful fetch the list once again
    //this should belong to the HoC?

    //this should call the api, change the status
    //if successful fetch the list once again and show it
    //if error show error.
    //it should show a loader while updating

    //this behaviour is reusable so it should belong in the HoC

    event.preventDefault();
    event.stopPropagation();
    delete entity.propertyTicker;
    this.props.onToggleListItem({
      id: entity.id,
      entity,
      activeProperty: "active",
      requestObjectActiveProperty: "isActive",
    });
  }

  handleDelete({ event, entity }) {
    //If successful fetch the list once again
    //this should belong to the HoC?

    //this should call the api, change the status
    //if successful fetch the list once again and show it
    //if error show error.
    //it should show a loader while updating

    //this behaviour is reusable so it should belong in the HoC

    event.preventDefault();
    event.stopPropagation();
    return this.props.onDeleteListItem({
      id: entity.id,
      entity,
    });
  }

  handleOnChangeTestEmailData({ formValues }) {
    return this.setState(formValues);
  }

  async handleSendTestEmail({ entity }) {
    console.log("send test email for reservation ");
    console.log(entity);
    console.log(this.state);
    const { destinationEmail, reservationId } = this.state;

    if (!destinationEmail || !reservationId) {
      return false;
    }

    try {
      await this.props.sendAPIRequest({
        options: {
          url: `${this.props.property.engineApiEndpoint}/api/emails/reservations`,
          method: "post",
          data: {
            hotelTicker: entity.hotelTicker,
            roomStayId: reservationId,
            type: entity.type,
            emailDestinationType: entity.emailDestinationType,
            ignoreDefaultRecipients: true,
            recipients: destinationEmail.split(","),
            emailTemplateId: entity.id,
          },
        },
        reloadEntities: false,
        ignoreState: true,
      });
      return true;
    } catch (error) {
      console.log(error);
      return false;
    }
  }

  async handlePromptSendTestEmail({ event, entity, idx }) {
    // We want to retrieve MyInput as a pure DOM node:
    const wrapper = document.createElement("div");
    const { destinationEmail, reservationId } = this.state;
    const root = createRoot(wrapper);

    root.render(
      <SwalTestEmailForm
        destinationEmail={destinationEmail}
        reservationId={reservationId}
        onChange={this.handleOnChangeTestEmailData}
        intl={this.props.intl}
      />
    );

    const value = await swal({
      title: this.props.intl.formatMessage(messages.sendTestEmail),
      text: this.props.intl.formatMessage(messages.sendTestEmailInstructions),
      icon: "warning",
      content: wrapper,
      buttons: {
        cancel: this.props.intl.formatMessage(messages.cancel),
        confirm: {
          text: this.props.intl.formatMessage(messages.send),
          closeModal: false,
          value: true,
        },
      },
      dangerMode: true,
    });
    if (value) {
      const result = await this.handleSendTestEmail({ entity });
      if (result) {
        this.displaySuccessAlert();
      } else {
        this.displayErrorAlert();
      }
    }
    return false;
  }

  emailDestinationTypeCell = ({ field, entity }) => {
    const fieldName = field && field.fieldName;
    const value = entity && entity[fieldName];
    return <FormattedMessage {...messages[value]} />;
  };

  render() {
    const { config, success, propertyConfig, isWitAdmin } = this.props;
    const { name, entityName, validation, fields, renderers } = config;
    const { entities, loading, entityError, entityResult, handleCreate, handleEdit } = this.props;
    const { handleToggle, handleDelete, getCustomActions } = this;
    renderers.emailDestinationType = this.emailDestinationTypeCell;
    const showAdvancedEmailsManager =
      propertyConfig && propertyConfig.showAdvancedEmailsManager === "1";
    return (
      <>
        {showAdvancedEmailsManager && (
          <div className="content-wrapper">
            <div className="content-heading">Emails</div>
            <EmailConfiguration isWitAdmin={isWitAdmin} />
          </div>
        )}
        <EntityList
          loading={loading}
          entityName={entityName}
          entities={entities}
          validation={validation}
          renderers={renderers}
          name={name}
          fields={fields}
          onToggle={handleToggle}
          onDelete={handleDelete}
          entityError={entityError}
          entityResult={entityResult}
          handleCreate={handleCreate}
          handleEdit={handleEdit}
          customActions={getCustomActions()}
          success={success}
        />
      </>
    );
  }
}

EmailTemplateList.propTypes = {
  // intl: intlShape.isRequired
};

EmailTemplateList.defaultProps = {};

export default withConfig(withPropertyConfiguration(injectIntl(EmailTemplateList)));
